import React from 'react';

const WordpressIcon = () => {
  return <img src='/skill-icons/wordpress.png' alt='wordpress-logo' />;
};

export default WordpressIcon;
